import { FormEvent, useState } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import BrandMark from '../components/BrandMark'
import { useLamsa } from '../context/LamsaContext'

export default function StaffLoginPage() {
  const { staffProfile, signInStaff, backendMode, restaurant } = useLamsa()
  const [email, setEmail] = useState('manager@avaxin.demo')
  const [password, setPassword] = useState('ChangeMe123!')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const target = (location.state as { from?: string } | null)?.from || '/app/foh'

  if (staffProfile) return <Navigate to={target} replace />

  async function submit(e: FormEvent) {
    e.preventDefault(); setBusy(true); setError('')
    try { await signInStaff(email, password); navigate(target) }
    catch (e) { setError(e instanceof Error ? e.message : 'Sign in failed.') }
    finally { setBusy(false) }
  }

  return (
    <div className="login-page">
      <div className="login-art">
        <BrandMark />
        <div><span className="eyebrow">STAFF WORKSPACE</span><h1>Service moves faster when everyone sees the same table.</h1><p>{restaurant.name} demo · FOH · BOH · Management · Studio</p></div>
      </div>
      <form className="login-card" onSubmit={submit}>
        <span className="eyebrow">{backendMode === 'demo' ? 'LOCAL DEMO MODE' : 'SUPABASE AUTH'}</span>
        <h2>Staff sign in</h2>
        <p>{backendMode === 'demo' ? 'Any values work in demo mode. Click the button to enter.' : 'Use a staff account attached to restaurant_staff.'}</p>
        <label>Email<input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required /></label>
        <label>Password<input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required /></label>
        {error && <div className="form-error">{error}</div>}
        <button className="button button-gold button-block" disabled={busy}>{busy ? 'Signing in…' : backendMode === 'demo' ? 'Enter Demo Staff' : 'Sign in'}</button>
      </form>
    </div>
  )
}
